import { z } from 'zod'

// "DrugIcd" is a reduced set of ICDs that I believe comes from joins on the
// drug data we buy from a third-party.  It comes with additional information
// that Dan tacks on that is useful for MedRecon and Diagnosis Review.
export const RDrugIcd = z.object({
	Icd10Code: z.string(),
	Description: z.string(),
	HistoryOf: z.nullable(z.string()),
	// 20260120 dan has given the clinical team free reign to display whatever
	// they want in the diagnosis review table for an ICD's comorbidity
	ComorbidityStatus: z.nullable(z.string()),
})
export type DrugIcd = z.infer<typeof RDrugIcd>

// "UnfilteredIcd" is a clean list of ICDs that was the full list of ICD codes
// available for a specific date of service.  These are used to allow auditors
// to "adhoc" tack on any valid ICD code to an assessment.
export const RUnfilteredIcd = z.object({
	Icd10Code: z.string(),
	Description: z.string(),
})
export type UnfilteredIcd = z.infer<typeof RUnfilteredIcd>
